import { api } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const changeSetNotesAndAssumptionsMailerService = {
  useSendReviewerEmail: (setLoading, changeSetId) => {
    const sendReviewerEmail = serviceMethods.useCreate({
      callback: useCallback(async () => {
        if (!changeSetId) {
          throw new Error('Change set ID is required');
        }
        const response = await api.create("/change_sets/".concat(changeSetId, "/send_reviewer_email"), {});
        return response;
      }, [changeSetId]),
      setLoading
    });
    return [sendReviewerEmail];
  },
  useSendResponseEmail: (setLoading, changeSetId) => {
    const sendResponseEmail = serviceMethods.useCreate({
      callback: useCallback(async () => {
        if (!changeSetId) {
          throw new Error('Change set ID is required');
        }
        const response = await api.create("/change_sets/".concat(changeSetId, "/send_response_email"), {});
        return response;
      }, [changeSetId]),
      setLoading
    });
    return [sendResponseEmail];
  }
};
export default changeSetNotesAndAssumptionsMailerService;